import { ReactNode } from 'react'
import clsx from 'clsx'
import { useAppSelector } from 'lib/redux'
import { selectOrganizationDisplayName } from 'lib/redux/auth'
import { Content, Header, Layout, Sider } from 'components/common'
import Menu from 'components/common/menu/StoreAdminMenu'
import NavHeader from './nav-header'
import * as styles from './styles.module.css'

export interface TemplateProps {
  children?: ReactNode
}

/**
 * サインイン済みの場合のページテンプレート
 */
export const Template = ({ children }: TemplateProps): JSX.Element => {
  const organizationName = useAppSelector(selectOrganizationDisplayName)

  return (
    <>
      <Layout className={clsx(styles.container)}>
        <Header className={clsx(styles.header)}>
          <NavHeader title={organizationName} />
        </Header>
        <Layout className={clsx(styles.container)} hasSider>
          <Sider className={clsx(styles.sider)}>
            <Menu />
          </Sider>
          <Content className={clsx(styles.content)}>{children}</Content>
        </Layout>
      </Layout>
    </>
  )
}

export default Template
